<div class="loading-overlay">
    <div>
        <div class="spinner"></div>
        <p class="fw-bold">{{ mensagem }}</p>
    </div>

</div>
